import { useState, useEffect } from 'react';
import { UseModalDismissalProps } from '../interface/interface';

export const useModalDismissal = ({
  permanentlyDismissedKey,
  temporarilyDismissedKey,
  isLoading = false,
  cartLineItems,
}: UseModalDismissalProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [hasLoadingCompleted, setHasLoadingCompleted] = useState(false);

  useEffect(() => {
    if (!cartLineItems?.length) return;
    const modalPermanentlyDismissed = localStorage.getItem(
      permanentlyDismissedKey,
    );
    const modalTemporarilyDismissed = sessionStorage.getItem(
      temporarilyDismissedKey,
    );

    const hasNonScript =
      cartLineItems?.some((x: any) => !x.requiresPrescription) ?? false;

    if (
      !modalPermanentlyDismissed &&
      !modalTemporarilyDismissed &&
      cartLineItems?.length > 0 &&
      !hasNonScript
    ) {
      // When loading transitions from true to false, show the modal
      if (!isLoading && !hasLoadingCompleted) {
        setIsModalOpen(true);
        setHasLoadingCompleted(true);
      }
    }
  }, [permanentlyDismissedKey, temporarilyDismissedKey, isLoading]);

  // Reset loading completion state when statrs again
  useEffect(() => {
    if (isLoading && hasLoadingCompleted) {
      console.log('🔄 Loading started again, resetting hasLoadingCompleted');
      setHasLoadingCompleted(false);
      setIsModalOpen(false);
    }
  }, [isLoading, hasLoadingCompleted]);

  const dismissModal = (permanent = false) => {
    if (permanent || dontShowAgain) {
      localStorage.setItem(permanentlyDismissedKey, 'true');
    } else {
      sessionStorage.setItem(temporarilyDismissedKey, 'true');
    }
    setIsModalOpen(false);
  };

  const closeModal = () => {
    if (dontShowAgain) {
      localStorage.setItem(permanentlyDismissedKey, 'true');
    } else {
      sessionStorage.setItem(temporarilyDismissedKey, 'true');
    }
    setIsModalOpen(false);
  };

  return {
    isModalOpen,
    setIsModalOpen,
    dontShowAgain,
    setDontShowAgain,
    dismissModal,
    closeModal,
  };
};
